import AppView from './AppView'
import ConfigQuery from 'Model/ConfigQuery'
import { QUERY } from 'Types'

class GraphView extends AppView
  @className = 'GraphView'

  constructor: (id) ->
    super(id)

  init: ->
    @set('type', QUERY)

  @getOpenDefault: ->
    (await new ConfigQuery()
      .type(@)
      .equalTo('openDefault', true)
      .find(@))[0]

  buildQueries: ->
    switch @get('queryType')
      when 'QueryBuilder'
        {
          query: new Weaver.QueryBuilder(@get('query')).build(),
          treeQuery: new Weaver.QueryBuilder(@get('treeQuery') or @get('query')).build()
        }
      when 'Sparql'
        {
          query: new Weaver.Sparql(@get('query')),
          treeQuery: new Weaver.Sparql(@get('treeQuery') or @get('query'))
        }
      else
        throw new Error("Unrecognized query type.")
export default GraphView
